import request from './../request.js'

// 列表渲染以及查询​/dev-api​/iot​/device​/operation​/list
export function operationList(query){
    return request({
      url: '/iot/device/operation/list.do?',
      method: 'get',
      params: query
    })
  }